// src/components/PaymentInfoNotice/PaymentInfoNotice.tsx

import React, { FC } from "react";
import { Box, Typography } from "@mui/material";

export type TPaymentMean = "STRIPE" | "PAYPAL";

type PaymentInfoNoticeProps = {
  paymentMean: TPaymentMean;
};

/**
 * Message de prévention affiché avant de finaliser un paiement, pour éviter
 * que le membre ne conteste un débit dont le libellé bancaire ne correspond
 * pas au nom de la plate-forme.
 */
const PaymentInfoNotice: FC<PaymentInfoNoticeProps> = ({ paymentMean }) =>
  paymentMean === "STRIPE" ? (
    <Typography variant="body2" component="p" sx={{ fontWeight: 500, mt: 2 }}>
      <b>⚠️ Information importante</b>
      <br />
      <br />
      Votre abonnement vous donne accès aux services de Zawaj Sounnah, un
      service exploité par Family Academy.
      <br />
      <br />
      Votre paiement sera encaissé par Family Academy et apparaîtra sous le
      nom « FAMILY ACADEMY » sur votre relevé bancaire.
      <br />
      Après paiement votre accès à la plate-forme sera débloquée
    </Typography>
  ) : (
    <Typography variant="body2" component="p" sx={{ fontWeight: 500, mt: 2 }}>
      <b>⚠️ Information importante</b>
      <br />
      <br />
      Votre paiement sera encaissé via PayPal et apparaîtra sous le nom{" "}
      <Box component="span" sx={{ whiteSpace: "nowrap" }}>
        «{" "}
        <Box
          component="b"
          sx={{
            display: "inline-block",
            color: "var(--ui-error)",
            fontWeight: 700,
            animation: "paymentInfoNoticePulse 2s ease-in-out infinite",
            "@keyframes paymentInfoNoticePulse": {
              "0%, 100%": { transform: "scale(1)" },
              "50%": { transform: "scale(1.06)" },
            },
          }}
        >
          Malabis-Collections
        </Box>{" "}
        »
      </Box>{" "}
      sur votre relevé PayPal ou bancaire.
    </Typography>
  );

export default PaymentInfoNotice;
